import * as React from 'react';
import Box from '@mui/system/Box';
import Grid from '@mui/system/Unstable_Grid';
import styled from '@mui/system/styled';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Button, Typography } from '@mui/material';
import axios from 'axios';
import { FaCaretLeft, FaRupeeSign } from 'react-icons/fa';
import Swal from 'sweetalert2';
import Row from 'react-bootstrap/esm/Row';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Product from './Product';
import Uom from './Uom';

const Item = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    border: '1px solid',
    borderColor: theme.palette.mode === 'dark' ? '#444d58' : '#ced7e0',
    padding: theme.spacing(1),
    borderRadius: '4px',
    textAlign: 'auto',
}));

export default function Createpurchasemaster({ onBack }) {

   
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const[product, setProduct] = React.useState('')
    const [uom, setUom] = React.useState('')

    const productData = (a) => {
        console.log(a);
        setProduct(a)
    }

    const uomData = (a) => {
        console.log(a);
        setUom(a)
    }
    
    const createpurchase = () => {
        const pl = Array.prototype.map.call(product, function (item) { return item.attachment }).join(",");
        const ol = Array.prototype.map.call(uom, function (item) { return item.attachment }).join(",");
        axios.post("https://buildfastvapi.emedha.in/pmaster/api/v1/add-productsmaster", {
            ProductName:pl,UOM:ol
        }).then((res) => {
            if (res.data.status === 200) {
                // setOpen(false)
                window.location.reload()
                Swal.fire({
                    icon: 'success',
                    title: "Success !",
                    text: "Data added successfully !",
                    confirmButtonColor: "rgb(126, 110, 228)",
                    cancelButtonColor: "#d33",
                    showCancelButton: false,
                    confirmButtonText: "Ok"
                }).then((result) => {
                    if (result.value) {
                        return
                    }
                })
            }
        })
    }
  

   


    return (
  <Box 
  sx={{ 
    display: "flex", 
    justifyContent: "center", 
    // Reduced outer padding so it sits closer to the top
    padding: { xs: "10px", md: "20px" }, 
    minHeight: "auto" // Removed 80vh so it only takes up the space it needs
  }}
>
  <Box
    sx={{
      width: "100%",
      maxWidth: "800px",
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      // Tighter inner padding
      padding: { xs: "15px", md: "24px" }, 
      boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.04)",
      border: "1px solid #E0E5F2",
    }}
  >
    {/* Premium Header */}
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}> {/* Reduced mb from 4 to 2 */}
      <div
        onClick={onBack}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "32px", // Slightly smaller back button
          height: "32px",
          backgroundColor: "#F4F7FE",
          borderRadius: "8px",
          cursor: "pointer",
          marginRight: "12px",
          transition: "all 0.2s ease"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#E9EDF7"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#F4F7FE"}
      >
        <FaCaretLeft style={{ color: "#4318ff", fontSize: "18px" }} />
      </div>
      <Typography
        sx={{
          fontSize: { xs: "18px", md: "20px" }, // Slightly smaller title
          fontWeight: "800",
          color: "#1B2559",
          letterSpacing: "-0.5px",
          margin: 0
        }}
      >
        Add Purchase Master
      </Typography>
    </Box>

    {/* Form Content - Tighter Gap */}
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}> {/* Reduced gap from 24px to 16px */}
      
      {/* Product Section */}
      <Box>
        <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
          Add Product
        </Typography>
        {/* Tighter padding inside the dashed box */}
        <Box sx={{ p: 1.5, backgroundColor: "#F8F9FF", borderRadius: "10px", border: "1px dashed #E0E5F2" }}>
          <Product productData={productData} />
        </Box>
      </Box>

      {/* UOM Section */}
      <Box>
        <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
          Add UOM
        </Typography>
        {/* Tighter padding inside the dashed box */}
        <Box sx={{ p: 1.5, backgroundColor: "#F8F9FF", borderRadius: "10px", border: "1px dashed #E0E5F2" }}>
          <Uom uomData={uomData} />
        </Box>
      </Box>

      {/* Submit Button */}
      <Button
        onClick={createpurchase}
        sx={{
          width: "100%",
          height: "45px", // Reduced height from 50px to 45px
          marginTop: "5px",
          background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)",
          color: "white",
          fontWeight: "700",
          fontSize: "14px",
          textTransform: "none",
          borderRadius: "10px",
          boxShadow: "0px 4px 15px rgba(67, 24, 255, 0.2)",
          transition: "transform 0.2s",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 20px rgba(67, 24, 255, 0.3)",
          }
        }}
      >
        Create Purchase
      </Button>
    </Box>
  </Box>
</Box>
    );
}